import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { KlPreferenceSaveFormComponent } from "@app/modules/shared/components/preference-form/kl-preference-save-form.component";
import { isArray } from "util";
import { get } from "lodash";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { ConvertIsoDateService } from "@app/modules/shared/services/convert-iso-date.service";
import { FilterItem } from "@app/modules/shared/model/detail-filter.interface";

@Component({
  selector: "kl-detail-filter",
  templateUrl: "./kl-detail-filter.component.html",
  styleUrls: ["./kl-detail-filter.component.scss"],
})
export class KlDetailFilterComponent implements OnInit {
  @ViewChild("entryModal", { static: true }) private entryModal: any;
  @ViewChild(forwardRef(() => KlPreferenceSaveFormComponent), {
    static: true,
  })
  klPreferenceSaveFormComponent: any;
  @Output() onSaveFilter = new EventEmitter<any>();
  @Output() onCommitFilter = new EventEmitter<any>();
  @Output() onSelectFilter = new EventEmitter<any>();
  @Output() onClearAll = new EventEmitter<any>();
  @Output() onDeleteFromValues = new EventEmitter<any>();
  @Output() onDeleteSavedFilter = new EventEmitter<any>();
  @Output() onCloseFilter = new EventEmitter<any>();
  @Output() onCloseAlert = new EventEmitter<any>();
  @Input() selectedFilterValues: Array<FilterItem> = [];
  @Input() filterList = [];
  @Input() currentFilter: any;
  @Input() alertMessage: string;
  @Input() alertShow = false;
  @Input() saveForm = false;
  @Input() showSavedFilters = true;
  @Input() showBottomButtons = true;

  get = get;

  constructor(
    private translateService: TranslateService,
    private dateConvert: ConvertIsoDateService
  ) {}

  ngOnInit() {}

  commitSave(event) {
    this.onSaveFilter.emit(event);
  }

  commitFilter() {
    this.onCommitFilter.emit();
  }

  isArray(value) {
    return !!Array.isArray(value);
  }

  isDate(value) {
    return value instanceof Date;
  }

  convertDate(value) {
    return this.dateConvert.convertDateAndTime(value);
  }

  getTranslated(item, accessor?) {
    let string = "";
    if (isArray(item)) {
      item.forEach((i) => {
        string += this.translateService.instant(get(i, accessor)) + ", ";
      });
      return string;
    } else if (item instanceof Date) {
      return this.dateConvert.convertDate(item);
    } else {
      if (accessor) {
        string += this.translateService.instant(get(item, accessor));
        return string;
      } else {
        string += this.translateService.instant(item);
        return string;
      }
    }
  }

  clearAll() {
    this.onClearAll.emit();
  }

  deleteFromValues(i: number, item: FilterItem) {
    this.onDeleteFromValues.emit({ index: i, item: item });
  }

  deleteSavedFilter(i: number, item: any) {
    this.onDeleteSavedFilter.emit({ index: i, item: item });
  }

  selectFilter(item, select = true) {
    this.onSelectFilter.emit({ item: item, select: select });
  }

  closeFilter() {
    this.onCloseFilter.emit();
  }

  closeAlert() {
    this.onCloseAlert.emit();
  }

  openEntryNameModal(commitType: string, currentFilter?: any) {
    this.klPreferenceSaveFormComponent.show(
      commitType,
      "filter",
      currentFilter
    );
  }

  closeEntryModal() {
    this.klPreferenceSaveFormComponent.hide();
  }
}
